// extracted by mini-css-extract-plugin
export default {"btn-pagination":"Pagination_btn-pagination__6zUcF","btn-perPage":"Pagination_btn-perPage__MjCD8"};